import React from 'react';
import styles from './styles.module.css';

const scrolledPastThreshold = 1000;

const isPastThreshold = () => window.scrollY > scrolledPastThreshold;

export default () => {
    const [show, setShow] = React.useState(isPastThreshold());

    React.useEffect(() => {
        const checkScroll = () => {
            setShow(isPastThreshold());
        };
        window.addEventListener('scroll', checkScroll);

        return () => {
            window.removeEventListener('scroll', checkScroll);
        };
    }, []);

    if (!show) {
        return null;
    }

    return (
        <button
            className={styles.container}
            onClick={() => {
                window.scrollTo({top: 0, behavior: 'smooth'});
            }}
        >
            <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M5 15L10 10L15 15"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </button>
    );
};
